<template>
	<div class="official-recommend-page">
		<div class="title">
			心愿单列表
		</div>
		<div class="officialList">
			<div class="offical-container" v-for="(item,index) in wishData" :key="index"
				@click="$router.push({path: '/work-details',query: {id:item.id,userId: item.user_id}})">
				<img class="bestIcon" src="../assets/Home/best.png" v-if="item.shuxing && item.shuxing == '精品图'" />
				<div class="likeNum">
					<img class="likeNumIcon" src="../assets/WorkDetails/iconL.png" />
					<span>{{item.zan_count}}</span>
				</div>
				<img class="likeIcon" :src="item.img" />
				<div class="likeTitle ellipsis-1">{{item.title}}</div>
				<div class="likeDesc ellipsis-2">
					{{item.content}}
				</div>
				<div class="tips">
					<div class="tip">
						{{item.cid}}
					</div>
					<div class="tip" v-for="(row,rowIndex) in item.yongtu" :key="rowIndex">
						{{row}}
					</div>
				</div>
				<div class="buyNow" @click.stop="changeCollection(item)">
					<img class="icon" src="../assets/WorkDetails/iconQ.png" alt="" />
					已加入心愿单
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'WishlistList',
		data() {
			return {
				wishData: [],
				artworks: [{
						id: 1,
						title: '山水意境',
						artist: '东方水墨',
						image: 'https://picsum.photos/id/1/600/400',
						views: 3200,
						likes: 850
					},
					{
						id: 2,
						title: '深海传说',
						artist: '海洋之心',
						image: 'https://picsum.photos/id/137/600/400',
						views: 2800,
						likes: 780
					},
					{
						id: 3,
						title: '都市肖像',
						artist: '城市之光',
						image: 'https://picsum.photos/id/1015/600/400',
						views: 4100,
						likes: 920
					},
					{
						id: 4,
						title: '自然奇观',
						artist: '山水之间',
						image: 'https://picsum.photos/id/1024/600/400',
						views: 3500,
						likes: 890
					},
					{
						id: 5,
						title: '古韵今风',
						artist: '建筑大师',
						image: 'https://picsum.photos/id/1043/600/400',
						views: 2900,
						likes: 750
					},
					{
						id: 6,
						title: '未来城市',
						artist: '科技先锋',
						image: 'https://picsum.photos/id/1067/600/400',
						views: 3800,
						likes: 910
					}
				]
			}
		},
		methods: {
			wishList() {
				this.$api.post('Hua/user_hua_list', {}).then(res => {
					if (res.code == 1) {
						this.wishData = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeCollection(item) {
				this.$api.post('/Hua/sc_work', {
					id: item.id
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.wishList()
					}
				}).catch(err => {
					console.log(err);
				})
			}
		},
		mounted() {
			this.wishList()
		}
	}
</script>

<style lang="scss" scoped>
	.official-recommend-page {
		width: 9.55rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		padding: .32rem .4rem;
	}

	.content-container {
		width: 9.55rem;
		display: flex;
		flex-direction: column;
		padding: .32rem .4rem;
	}

	.title {
		font-weight: 600;
		font-size: .16rem;
		color: #333333;
	}

	.officialList {
		width: 9.55rem;
		display: flex;
		flex-wrap: wrap;

		.offical-container {
			margin-top: .24rem;
			display: flex;
			flex-direction: column;
			margin-right: .24rem;
			position: relative;
			cursor: pointer;

			.bestIcon {
				position: absolute;
				top: 0;
				left: 0;
				width: .67rem;
				height: .67rem;
			}

			.likeNum {
				position: absolute;
				top: .16rem;
				right: .16rem;
				height: .24rem;
				display: flex;
				align-items: center;
				padding: 0 .1rem;
				background: rgba(255, 255, 255, .9);
				box-shadow: 0px 2px 15px 0px rgba(176, 176, 176, 0.6);
				border-radius: 12px;
				font-weight: 500;
				font-size: .14rem;
				color: #333333;

				.likeNumIcon {
					margin-right: .02rem;
					width: .15rem;
					height: .14rem;
				}

				span {
					margin-top: .02rem;
				}
			}

			.likeIcon {
				width: 2.05rem;
				height: 2.76rem;
				object-fit: cover;
				border-radius: .08rem;
			}

			.likeTitle {
				width: 2.05rem;
				margin-top: .24rem;
				font-weight: 600;
				font-size: .24rem;
				color: #000000;
				line-height: .32rem;
			}

			.likeDesc {
				width: 2.05rem;
				margin-top: .06rem;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
				line-height: .2rem;
			}

			.tips {
				margin-top: .12rem;
				display: flex;
				align-items: center;

				.tip {
					height: .26rem;
					margin-right: .12rem;
					padding: .04rem .08rem;
					font-weight: 400;
					font-size: .12rem;
					color: #7C3E0B;
					border-radius: .13rem;
					border: .01rem solid #A88653;
				}
			}

			.buyNow {
				margin: .16rem auto 0;
				width: 1.9rem;
				height: .4rem;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: .04rem;
				border: .01rem solid #CCCCCC;
				font-weight: 400;
				font-size: .12rem;
				color: #999999;
				cursor: pointer;

				.icon {
					width: .16rem;
					height: .16rem;
					margin-right: .06rem;
				}
			}
		}
	}
</style>